import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { GridColDef } from "@mui/x-data-grid";
import Moment from "react-moment";
import { Link } from "react-router-dom";

import { UserProfile, UserRole } from "../../../../store/auth/types";
import { DocumentType, RequestStatus, RequestType } from "../../../Enum";

interface CorporateLegalColumnsProps {
  profile: UserProfile;
  profileRole: UserRole;
  binusianUnderLevel: string[];
}

export function CorporateLegalColumns({
  profile,
  profileRole,
  binusianUnderLevel,
}: CorporateLegalColumnsProps): GridColDef[] {
  return [
    {
      field: "action",
      headerAlign: "center",
      align: "center",
      width: 95,
      renderHeader: () => <b>Action</b>,
      renderCell: (params) => {
        if (profileRole.roleId === "RL230000003") {
          return (
            <div style={{ display: "flex", flexDirection: "row" }}>
              {((params.row.requestStatus === RequestStatus.Draft &&
                params.row.binusianID === profile.BinusianId) ||
                (params.row.requestStatus === RequestStatus.Pending &&
                  params.row.binusianID === profile.BinusianId) ||
                (params.row.requestStatus === RequestStatus.Pending &&
                  binusianUnderLevel.includes(params.row.binusianID))) && (
                <Link
                  to={`/edit/${params.row.requestID}`}
                  style={{ width: "30px" }}
                >
                  <EditOutlinedIcon className="pencilAction" />
                </Link>
              )}

              {(params.row.requestStatus === RequestStatus.SendBack ||
                params.row.requestStatus === RequestStatus.RequestReceive ||
                params.row.requestStatus === RequestStatus.RequestRevise) && (
                <Link
                  to={`/approvalcl/${params.row.requestID}`}
                  style={{ width: "30px" }}
                >
                  <EditOutlinedIcon className="pencilAction" />
                </Link>
              )}

              {((params.row.requestStatus === RequestStatus.NeedResponse &&
                params.row.documentType === DocumentType.Hardcopy &&
                params.row.needSK == true) ||
                ((params.row.requestStatus === RequestStatus.FinishedRevised ||
                  params.row.requestStatus === RequestStatus.Finished) &&
                  params.row.documentType === DocumentType.Hardcopy &&
                  (params.row.requestType === RequestType.SuratKuasa ||
                    (params.row.requestType === RequestType.DokumenMaster &&
                      params.row.needSK == true)))) && (
                <Link
                  to={`/clsendsk/${params.row.requestID}`}
                  style={{ width: "30px" }}
                >
                  <EditOutlinedIcon className="pencilAction" />
                </Link>
              )}

              {(((params.row.requestStatus === RequestStatus.Finished ||
                params.row.requestStatus === RequestStatus.FinishedRevised) &&
                params.row.requestType == RequestType.DokumenMaster &&
                (params.row.needSK == false || params.row.needSK == null)) ||
                ((params.row.requestStatus === RequestStatus.FinishedRevised ||
                  params.row.requestStatus === RequestStatus.Finished) &&
                  params.row.requestType === RequestType.DokumenMaster &&
                  params.row.documentType === DocumentType.Softcopy &&
                  params.row.needSK == true)) && (
                <Link
                  to={`/editfinishcl/${params.row.requestID}`}
                  style={{ width: "30px" }}
                >
                  <EditOutlinedIcon className="pencilAction" />
                </Link>
              )}

              <Link
                to={`/view/${params.row.requestID}`}
                style={{ width: "30px" }}
              >
                <SearchOutlinedIcon className="black" />
              </Link>
            </div>
          );
        }

        return "";
      },
    },
    {
      field: "requestStatus",
      width: 150,
      renderHeader: () => <b>Request Status</b>,
      renderCell: (params) => {
        if (profileRole.roleId === "RL230000003") {
          return (
            <div style={{ display: "flex", flexDirection: "row" }}>
              {((params.row.requestStatus === RequestStatus.Draft &&
                params.row.binusianID === profile.BinusianId) ||
                (params.row.requestStatus === RequestStatus.Pending &&
                  params.row.binusianID === profile.BinusianId) ||
                (params.row.requestStatus === RequestStatus.Pending &&
                  binusianUnderLevel.includes(params.row.binusianID))) && (
                <Link
                  to={`/edit/${params.row.requestID}`}
                  style={{ color: "#6C2882" }}
                >
                  {params.row.requestStatus}
                </Link>
              )}

              {(params.row.requestStatus === RequestStatus.SendBack ||
                params.row.requestStatus === RequestStatus.RequestRevise ||
                params.row.requestStatus === RequestStatus.RequestReceive) && (
                <Link
                  style={{ color: "#6C2882" }}
                  to={`/approvalcl/${params.row.requestID}`}
                >
                  {params.row.requestStatus}
                </Link>
              )}

              {
                // (params.row.requestStatus === RequestStatus.Finished &&
                // params.row.requestType === RequestType.DokumenMaster &&
                // params.row.documentType === DocumentType.Softcopy &&
                // params.row.signerBinusianID.trim() !==
                // params.row.buLeaderBinusianID.trim()) ||
                ((params.row.requestStatus === RequestStatus.Finished &&
                  params.row.requestType === RequestType.SuratKuasa &&
                  params.row.documentType === DocumentType.Softcopy) ||
                  // (params.row.requestStatus === RequestStatus.FinishedRevised &&
                  //   params.row.requestType === RequestType.DokumenMaster &&
                  //   params.row.documentType === DocumentType.Softcopy &&
                  //   params.row.signerBinusianID.trim() !==
                  //         params.row.buLeaderBinusianID.trim()) ||
                  (params.row.requestStatus === RequestStatus.FinishedRevised &&
                    params.row.requestType === RequestType.SuratKuasa &&
                    params.row.documentType === DocumentType.Softcopy) ||
                  params.row.requestStatus ===
                    RequestStatus.AwaitingConfirmation ||
                  params.row.requestStatus === RequestStatus.FinishedCanceled ||
                  // (params.row.requestStatus === RequestStatus.Pending &&
                  //   params.row.binusianID !== profile.binusianID) ||
                  (params.row.requestStatus === RequestStatus.Pending &&
                    !binusianUnderLevel.includes(params.row.binusianID) &&
                    params.row.binusianID !== profile.BinusianId) ||
                  params.row.requestStatus === RequestStatus.Canceled ||
                  params.row.requestStatus === RequestStatus.Rejected) && (
                  <Link
                    style={{ color: "#6C2882" }}
                    to={`/view/${params.row.requestID}`}
                  >
                    {params.row.requestStatus}
                  </Link>
                )
              }

              {(((params.row.requestStatus === RequestStatus.Finished ||
                params.row.requestStatus === RequestStatus.FinishedRevised) &&
                params.row.requestType === RequestType.DokumenMaster &&
                (params.row.needSK == false || params.row.needSK == null)) ||
                ((params.row.requestStatus === RequestStatus.Finished ||
                  params.row.requestStatus === RequestStatus.FinishedRevised) &&
                  params.row.requestType === RequestType.DokumenMaster &&
                  params.row.documentType === DocumentType.Softcopy &&
                  params.row.needSK == true)) && (
                <Link
                  style={{ color: "#6C2882" }}
                  to={`/editfinishcl/${params.row.requestID}`}
                >
                  {params.row.requestStatus}
                </Link>
              )}

              {((params.row.requestStatus === RequestStatus.NeedResponse &&
                params.row.documentType === DocumentType.Hardcopy) ||
                ((params.row.requestStatus === RequestStatus.Finished ||
                  params.row.requestStatus === RequestStatus.FinishedRevised) &&
                  params.row.documentType === DocumentType.Hardcopy &&
                  (params.row.requestType === RequestType.SuratKuasa ||
                    (params.row.requestType === RequestType.DokumenMaster &&
                      params.row.needSK == true)))) && (
                <Link
                  style={{ color: "#6C2882" }}
                  to={`/clsendsk/${params.row.requestID}`}
                >
                  {params.row.requestStatus}
                </Link>
              )}
            </div>
          );
        }

        return "";
      },
    },
    {
      field: "requestNumber",
      width: 220,
      renderHeader: () => <b>Request No.</b>,
    },
    {
      field: "requestDate",
      width: 180,
      renderHeader: () => <b>Request Date</b>,
      renderCell: (params) => (
        <div>
          <Moment format="DD MMMM YYYY">{params.row.requestDate}</Moment>
        </div>
      ),
    },
    {
      field: "binusianName",
      width: 150,
      renderHeader: () => <b>Name</b>,
    },
    {
      field: "businessUnit",
      width: 170,
      renderHeader: () => <b>Business Unit</b>,
      renderCell: (params) =>
        params.row.businessUnit != params.row.department ? (
          <div>
            {params.row.businessUnit} - {params.row.department}
          </div>
        ) : (
          <div>{params.row.businessUnit}</div>
        ),
    },
    { field: "noCRR", width: 170, renderHeader: () => <b>CRR No.</b> },
    {
      field: "counterpart",
      width: 250,
      renderHeader: () => <b>Counterpart</b>,
    },
    {
      field: "requestType",
      width: 150,
      renderHeader: () => <b>Request Type</b>,
    },
    {
      field: "documentType",
      width: 150,
      renderHeader: () => <b>Document Type</b>,
    },
    {
      field: "poaDate",
      width: 180,
      renderHeader: () => <b>POA Date</b>,
      renderCell: (params) => (
        <div>
          <Moment format="DD MMMM YYYY">{params.row.poaDate}</Moment>
        </div>
      ),
    },
    {
      field: "noPOA",
      width: 250,
      renderHeader: () => <b>POA No.</b>,
      renderCell: (params) => (
        <div>
          {params.row.noPOA}
          <br />
          {params.row.noSubstitution}
        </div>
      ),
    },
  ];
}
